<template>
<div class="ranking-list">
  <div
    class="row"
    v-loading="ticketsLoading"
  >
    <div class="col-lg-7 col-xs-12">
      <ranking-list-winners
        @cancelTicket="cancelTicket($event)"
        :tickets="ticketsWinners"
      ></ranking-list-winners>
    </div>
    <div class="col-lg-5 col-xs-12">
      <ranking-list-reserves :tickets="ticketsReserves"></ranking-list-reserves>
    </div>
  </div>

  <div class="row ranking-list">
    <div class="col-xs-12">
      <ranking-list-absent :tickets="ticketsClosed"></ranking-list-absent>
    </div>
  </div>
</div>
</template>

<script>
import RankingListWinners from './RankingListWinners'
import RankingListReserves from './RankingListReserves'
import RankingListAbsent from './RankingListAbsent'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ranking-list',

  props: {
    tickets: {
      required: true
    },

    surveys: {
      required: true
    },

    ticketsLoading: {
      required: true
    }
  },

  components: {
    RankingListWinners,
    RankingListReserves,
    RankingListAbsent
  },

  computed: {
    ...mapGetters('events', {
      event: 'event'
    }),
    ...mapGetters('tickets', {
      ticketLoading: 'loading'
    }),

    ticketsWinners () {
      return this.tickets.filter(ticketFilter => {
        return ticketFilter.eligible && ticketFilter.winner
      }).sort((a, b) => {
        return a.rankingNow - b.rankingNow
      })
    },

    ticketsReserves () {
      return this.tickets.filter(ticketFilter => {
        return ticketFilter.eligible && !ticketFilter.winner && !ticketFilter.hasOwnProperty('absentAt')
      }).sort((a, b) => {
        return a.rankingNow - b.rankingNow
      })
    },

    ticketsClosed () {
      return this.tickets.filter(ticketFilter => {
        return ticketFilter.eligible && !ticketFilter.winner && ticketFilter.hasOwnProperty('absentAt')
      })
    },

    newWinner () {
      return this.ticketsReserves.reduce((accum, current, index) => {
        return accum && accum.rankingNow < current.rankingNow ? accum : current
      }, {})
    }
  },

  methods: {
    ...mapActions('tickets', { ticketCancel: 'ticketCancel' }),

    cancelTicket (ticketId) {
      let ticketOut = Object.assign({}, this.tickets.find(ticketFind => {
        return ticketFind._id === ticketId
      }))

      let ticketIn = Object.assign({}, this.ticketsReserves.reduce((accum, current, index) => {
        return accum && accum.rankingNow < current.rankingNow ? accum : current
      }, {})) // Pega o primeiro/menor da lista

      let logTicketOut = { old: ticketOut }
      ticketOut.checkIn = false
      ticketOut.energyMetering = false
      ticketOut.winner = false
      ticketOut.absentAt = new Date()
      // ticketOut.rankingNow = this.ticketsClosed.length + 1
      logTicketOut.new = Object.assign({}, ticketOut)

      let logTicketIn = { old: ticketIn }
      ticketIn.winner = true

      let ticketsNewWinners = this.recreateRanking(ticketIn, ticketOut)
      let remainingTicketsReserved = this.getRemainingSortedTicketsReserved()

      let logs = this.getLoggers(logTicketOut, logTicketIn, ticketsNewWinners)

      this.ticketCancel({
        tickets: [ticketOut, ...ticketsNewWinners, ...remainingTicketsReserved], // Add all tickets to update
        logs: logs
      })
    },

    recreateRanking (ticketIn, ticketOut) {
      let ticketsNewWinners = this.ticketsWinners
      ticketsNewWinners.push(ticketIn)

      return this.ticketsWinners
        .filter(item => {
          return item._id !== ticketOut._id
        })
        .sort((a, b) => {
          return a.rankingNow - b.rankingNow
        }).map((ticket, index) => {
          ticket.rankingNow = index + 1
          return ticket
        })
    },

    getLoggers (logTicketOut, logTicketIn, ticketsNewWinners) {
      let logWinners = ticketsNewWinners.map(newTicket => {
        // Search ticket that was not removed/canceled
        let oldTicket = this.ticketsWinners.find(oldTicketWinner => {
          return oldTicketWinner._id === newTicket._id
        })

        if (!oldTicket && logTicketIn.old._id === newTicket._id) {
          oldTicket = logTicketIn.old
        }

        return {
          old: oldTicket,
          new: newTicket
        }
      })

      return [logTicketOut, ...logWinners]
    },

    getRemainingSortedTicketsReserved () {
      return this.ticketsReserves
        .filter(reserved => {
          return reserved._id !== this.newWinner._id
        })
        .sort((a, b) => {
          return a.rankingNow - b.rankingNow
        })
        .map((ticket, index) => {
          ticket.rankingNow = index + parseInt(this.event.numberOfRefigerators) + 1
          return ticket
        })
    }
  }
}
</script>

<style scoped>
  .row .ranking-list {
    margin-top: 30px;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Ranking/RankingList.vue